// 去除结尾标点
String.prototype.removePunctuation = function (punctuation) {
  let str = this
  if (str.length > 0) {
    if (str.substr(str.length - 1, 1) == punctuation) {
      str = str.substr(0, str.length - 1);
    }
  }
  return String(str)
}


// WEBPACK FOOTER //
// ./src/plugins/string.help.js